// extracted by mini-css-extract-plugin
export var fullHeightState = "_5g-7";
export var headerCell = "_5g-1";
export var loadingStateCell = "_5g-4";
export var rowWrapper = "_5g-3";
export var standaloneTable = "_5g-8";
export var standaloneTableWithBodyFill = "_5g-9";
export var stateCell = "_5g-5";
export var table = "_5g-0";
export var tableBodyFiller = "_5g-6";
export var white = "_5g-2";